import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

/**
 * Alle Textfarben laufen über `text.primary` statt über festgenagelte Werte.
 * Vorher stand hier `#000 !important` bzw. `rgba(0, 0, 0, 0.87)` — bei
 * `dense` liegt die Komponente auf einer transparenten Fläche und damit direkt
 * auf dem Grund des Aufrufers (in den Custom-Sektionen `surfaceRecessed`), im
 * Dark Mode also schwarz auf #181818 mit 1.18:1.
 *
 * `rgba(0, 0, 0, 0.87)` ist genau MUIs `text.primary` im Light-Modus, der
 * Light-Zustand bleibt damit unverändert. Das `!important` ist entfallen: es
 * gab keine konkurrierende Regel — die globalen Heading-Farben in index.css
 * greifen nur auf `h1`/`h2` unter `.page-content` und in `.header-banner`, hier
 * rendert ein `h6`.
 *
 * Die Werte sind sx-Pfad-Strings, weil `styles` per `sx` angewandt wird.
 */
const styles = {
  root: {
    width: '100%',
    marginTop: '20px',
    padding: '24px 16px'
  },
  title: {
    color: 'text.primary',
    textAlign: 'center',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '400',
    lineHeight: '1.6',
    letterSpacing: '0.0075em',
    marginTop: '10px',
    marginBottom: '10px'
  },
  description: {
    color: 'text.primary',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: '1.5em',
    textAlign: 'center'
  },
  bottom: {
    color: 'text.primary',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: '1.5em',
    textAlign: 'center'
  },
  rootDense: {
    background: 'transparent',
    padding: '12px',
    margin: 0,
    boxShadow: 'none',
  },
  titleDense: {
    color: 'text.primary',
    textAlign: 'center',
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '400',
    lineHeight: '1.6',
    letterSpacing: '0.0075em',
    marginTop: '10px',
    marginBottom: '10px'
  },
  descriptionDense: {
    color: 'text.primary',
    fontSize: '0.8rem',
    fontWeight: '400',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: '1.5em',
    textAlign: 'center',
    paddingLeft: '50px',
    paddingRight: '50px',
  },
  bottomDense: {
    color: 'text.primary',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: '1.5em',
    textAlign: 'center'
  },
};

class EmptyView extends React.Component {

  render() {
    const { title, description, bottom, dense } = this.props;

    return (
      <Paper sx={dense ? styles.rootDense : styles.root}>
          <Box component="h6" sx={dense ? styles.titleDense : styles.title}>{title}</Box>
          {description && <Box component="p" sx={dense ? styles.descriptionDense : styles.description}>{description}</Box>}
          {bottom && <Box component="p" sx={dense ? styles.bottomDense : styles.bottom}>{bottom}</Box>}
      </Paper>
    );
  }
}

export default EmptyView;
